<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @distribuir="distribuir($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
    >
      <template slot="alert"> </template>
    </tablita>

    <!-- Modal -->
    <div
      class="modal fade"
      id="distribucion_pozo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              DISTRIBUCIÓN DE MATERIA PRIMA A POZOS
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="flex">
                    <h2>Estado Actual de Pozos</h2>
                    
                    <div class="flex-inline">
                        <div class="badge-rounded-min bg-red-light"></div>
                        <p>Pozo Con Restriccion</p>
                        <div class="badge-rounded-min bg-green-light"></div>
                        <p>Pozo Sin Restriccion</p>
                    </div>

                </div>
            <div class="row mb-4">
                    <div v-for="p in pozos" :key="p.id" :class="`badge-rounded ${p.clase}`">
                        {{p.nombre}}
                    </div>
                </div>
            <div class="row">
              <div class="col">
                <table
                  class="table table-bordered"
                  v-if="ticket_actual.cantidad_bins_proceso != null"
                >
                  <thead class="thead-blue">
                    <tr>
                      <th class="text-center">PATENTE</th>
                      <th class="text-center">TICKET</th>
                      <!-- <th class="text-center">GUIAS</th> -->
                      <!-- <th class="text-center">PATENTE</th> -->
                      <th class="text-center">TOTAL BINS PROCESO</th>
                      <th class="text-center">TOTAL KILOS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{ ticket_actual.patente }}</td>
                      <td class="text-center">
                        {{ ticket_actual.codigo_ticket }}
                      </td>
                      <!-- <td class="text-center">{{ticket_actual.guias}}</td> -->
                      <!-- <td class="text-center">{{ticket_actual.total_bins_guias}}</td> -->

                      <td class="text-center">
                        {{ ticket_actual.cantidad_bins_proceso }}
                      </td>
                      <td class="text-center">{{ ticket_actual.peso_real }}</td>
                    </tr>
                  </tbody>
                </table>

                <table
                  class="table table-bordered"
                  v-if="ticket_actual.cantidad_bins_proceso == null"
                >
                  <thead class="thead-blue">
                    <tr>
                      <th class="text-center">PATENTE</th>
                      <th class="text-center">TICKET</th>

                      <th class="text-center">MATERIA PRIMA</th>
                      <!-- <th class="text-center">TOTAL BINS</th> -->
                      <th class="text-center">TOTAL KILOS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{ ticket_actual.patente }}</td>
                      <td class="text-center">
                        {{ ticket_actual.codigo_ticket }}
                      </td>
                      <td class="text-center">
                        {{ ticket_actual.materia_prima }}
                      </td>
                      <!-- <td class="text-center">{{ticket_actual.total_bins_guias}}</td> -->
                      <td class="text-center">{{ ticket_actual.peso_real }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <pre>{{ticket_actual}}</pre> -->
              </div>
            </div>

            <div class="row">
              <div class="col">
                <table
                  class="table table-bordered"
                  v-if="ticket_actual.cantidad_bins_proceso != null"
                >
                  <thead class="background-blue">
                    <tr>
                      <th class="text-center">GUIA</th>
                      <th class="text-center">DESTINO</th>
                      <th class="text-center">TOTAL BINS PROCESO</th>
                      <th class="text-center">BINS RESTANTES</th>
                      <th class="text-center">TOTAL KILOS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, idx) in distribuciones" :key="idx" :class="d.tiene_restriccion == 1?'background-red-1':''">
                      <td class="text-center">
                        {{ d.numero_guia }}
                        <button
                          class="btn btn-danger btn-sm btn-icon"
                          type="button"
                          @click="abrirPdf(d.link)"
                        >
                          <span class="btn-inner--icon"
                            ><i class="fas fa-file-pdf"></i
                          ></span>
                        </button>
                        <!-- <span class="btn-inner--icon" style="cursor:pointer; color:red;" @click="abrirPdf(d.link)"><i class="fas fa-file-pdf"></i></span> -->
                      </td>
                      <td class="text-center">{{ d.destino_distribucion }}</td>
                      <td class="text-center">{{ d.cantidad_bins }}</td>
                      <td class="text-center">{{ d.bins_restantes }}</td>
                      <td class="text-center">{{ d.peso_real }}</td>
                    </tr>
                  </tbody>
                </table>

                <table
                  class="table table-bordered"
                  v-if="ticket_actual.cantidad_bins_proceso == null"
                >
                  <thead class="background-blue">
                    <tr>
                      <th class="text-center">GUIA</th>
                      <th class="text-center">DESTINO</th>
                      <th class="text-center">TOTAL KILOS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, idx) in distribuciones" :key="idx" :class="d.tiene_restriccion == 1?'background-red-1':''">
                      <td class="text-center">{{ d.numero_guia }}</td>
                      <td class="text-center">{{ d.destino_distribucion }}</td>
                      <td class="text-center">{{ d.peso_real }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div
                  :class="`alert ${alert_clase} alert-dismissible fade show`"
                  role="alert"
                  v-if="alert"
                >
                  <span class="alert-icon"><i :class="alert_icono"></i></span>
                  <span class="alert-text"
                    ><strong>{{ alert_mensaje }}</strong></span
                  >
                  <ul>
                    <li class="" v-for="(e, idx) in alert_errores" :key="idx">
                      {{ e }}
                    </li>
                  </ul>
                  <button
                    type="button"
                    class="close"
                    @click="alert = !alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col">
                <h3>KILOS RESTANTES: {{ kilos_restantes }}</h3>
              </div>
              <div class="col">
                <h3 v-if="ticket_actual.cantidad_bins_proceso != null">
                  BINS RESTANTES: {{ bins_restantes }}
                </h3>
              </div>
              <div class="col">
                <button
                  class="btn btn-success btn-sm float-right"
                  @click="agregar_distribucion_pozo"
                >
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div
                  :class="`alert ${alert_distribucion_clase} alert-dismissible fade show`"
                  role="alert"
                  v-if="alert_distribucion"
                >
                  <span class="alert-icon"
                    ><i :class="alert_distribucion_icono"></i
                  ></span>
                  <span class="alert-text"
                    ><strong>{{ alert_distribucion_mensaje }}</strong></span
                  >

                  <button
                    type="button"
                    class="close"
                    @click="alert_distribucion = !alert_distribucion"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>

            <table
              class="table table-bordered"
              v-if="ticket_actual.cantidad_bins_proceso != null"
            >
              <thead class="background-salmon-1">
                <tr>
                  <th class="text-center">Guía (N° Bins)</th>
                  <th class="text-center">Pozo</th>
                  <th class="text-center">Cantidad Bins</th>
                  <th class="text-center">Cantidad (Kg)</th>
                  <th class="text-center">Eliminar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dp, idx) in distribuciones_pozo" :key="idx">
                  
                  <td>
                    <select name="" id="" v-model="dp.guia_distribuciones_id">
                      <option
                        :value="d.guia_distribuciones_id"
                        v-for="(d, i) in distribuciones"
                        :key="i"
                      >
                        {{
                          `${d.numero_guia} ${
                            d.cantidad_bins != null
                              ? `(${d.cantidad_bins} Bins)`
                              : ""
                          }`
                        }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select name="" id="" v-model="dp.pozos_id">
                      <option :value="p.id" v-for="(p, i) in retornar_pozos(dp.guia_distribuciones_id)" :key="i" :class="p.clase">
                        {{ p.nombre }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <input
                      :disabled="dp.guia_distribuciones_id == null"
                      v-if="ticket_actual.cantidad_bins_proceso != null"
                      type="number"
                      v-model="dp.cantidad_bins"
                      @input="actualizar_cantidad_kilos(dp, idx)"
                    />
                  </td>
                  <td>
                    <input type="number" v-model="dp.cantidad_kilos" />
                  </td>
                  <td class="text-center">
                    <button
                      class="btn btn-danger btn-sm"
                      @click="eliminar_distribucion_pozo(dp, idx)"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              class="table table-bordered"
              v-if="ticket_actual.cantidad_bins_proceso == null"
            >
              <thead class="background-salmon-1">
                <tr>
                  <th class="text-center">Guía (N° Bins)</th>
                  <th class="text-center">Pozo</th>
                  <th class="text-center">Seleccione Cantidad Estanque</th>
                  <th class="text-center">Cantidad (Kg)</th>
                  <th class="text-center">Eliminar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dp, idx) in distribuciones_pozo" :key="idx">
                  <td>
                    <select name="" id="" v-model="dp.guia_distribuciones_id">
                      <option
                        :value="d.guia_distribuciones_id"
                        v-for="(d, i) in distribuciones"
                        :key="i"
                      >
                        {{
                          `${d.numero_guia} ${
                            d.cantidad_bins != null
                              ? `(${d.cantidad_bins} Bins)`
                              : ""
                          }`
                        }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select name="" id="" v-model="dp.pozos_id">
                      <option :value="p.id" v-for="(p, i) in retornar_pozos(dp.guia_distribuciones_id)" :key="i" :class="p.clase">
                        {{ p.nombre }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      :disabled="dp.guia_distribuciones_id == null"
                      v-model="dp.division_estanque"
                      name=""
                      id=""
                      @change="distribucion_pozo_estanque(dp, idx)"
                    >
                      <option value="">--Seleccione--</option>
                      <option value="1">Estanque Completo</option>
                      <option value="2">1/2 Estanque</option>
                    </select>
                  </td>
                  <td>
                    <input type="number" v-model="dp.cantidad_kilos" />
                  </td>
                  <td class="text-center">
                    <button
                      class="btn btn-danger btn-sm"
                      @click="eliminar_distribucion_pozo(dp, idx)"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- <pre>{{distribuciones_pozo}}</pre> -->
            <!-- <pre>{{distribuciones}}</pre> -->
            <!-- <pre>{{distribucion_actual}}</pre> -->
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-default" data-dismiss="modal">cerrar</button> -->
            <button
              type="button"
              class="btn btn-success"
              @click="guardar_distribuciones_pozo()"
            >
              <i class="fas fa-save"></i> GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "fecha_hora_ingreso",
        label: "Fecha Ingreso",
        busqueda: "",
        tipo: "datetime",
        searchable: true,
        path: "fecha_hora_ingreso",
      },
      {
        key: "codigo_ticket",
        label: "Ticket",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "codigo_ticket",
      },
      {
        key: "patente",
        label: "Patente",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "patente",
      },
      {
        key: "numero_guia",
        label: "Guía (N° Bins)",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "guias",
      },
      {
        key: "restricciones",
        label: "Restriccion",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "restricciones",
      },
      {
        key: "mp",
        label: "Materia Prima",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "materia_prima",
      },
      //{key:'guias_id',label:'Guía',busqueda:'',tipo:'select-loadable',ruta:'/guias',parametro:'numero_guia',searchable:true,path:'guia.numero_guia',opciones:[],valor_opcion:'id',label_opcion:'numero_guia'},
      //{key:'tickets_id',label:'Ticket',busqueda:'',tipo:'select-loadable',ruta:'/tickets',parametro:'codigo_ticket',searchable:true,path:'ticket_texto',opciones:[],valor_opcion:'id',label_opcion:'codigo_ticket'},
      {
        key: "empresa",
        label: "Empresa",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "empresa",
      },
      {
        key: "sucursal",
        label: "Sucursal",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "sucursal",
      },
      {
        key: "destino",
        label: "Destino",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "destino",
      },
      {
        key: "estado",
        label: "Estado",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "estado",
        opciones: [
          { id: 1, valor: "COMPLETADO" },
          { id: 2, valor: "PENDIENTE" },
        ],
        valor_opcion: "id",
        label_opcion: "valor",
      },

      //{key:'restriccion',label:'Restriccion',busqueda:'',tipo:'string',searchable:false,path:'guia.restricciones_texto'},
      {
        key: "peso_real_distribucion",
        label: "Cantidad (Kg)",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "peso_real",
      },
      {
        key: "cantidad_bins_proceso",
        label: "Cantidad Bins Proceso",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "cantidad_bins_proceso",
      },
      {
        key: "cantidad_bins",
        label: "Total Bins",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "total_bins_guias",
      },
      //{key:'cantidad_distribuida',label:'Distribuido en Pozo (Kg)',busqueda:'',tipo:'string',searchable:false,path:'cantidad_distribuida'},
      //{key:'pozos_id',label:'Seleccione Pozo Destino',busqueda:'',tipo:'select-editable',ruta:'/pozos',parametro:'nombre',searchable:true,path:'pozo_texto',opciones:[],valor_opcion:'id',label_opcion:'linea_pozo'},
      //{key:'fecha_hora_pozo_texto',label:'Fecha|Hora Descarga Pozo',busqueda:'',tipo:'string-editable',placeholder:'dd-mm-aaaa hh:mm',searchable:false,path:'fecha_hora_pozo_texto'},
    ],
    botones: [
      //{label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'}
      {
        label: "Distribucion Pozo",
        clase: "btn-default",
        evento: "distribuir",
        icono: "fas fa-boxes",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      /* {cols:4,tipo:'numero',key:'codigo_ticket',valor:'',label:'N° Ticket (*)'},
          {cols:4,tipo:'select',key:'ciclo_ticket',valor:'',label:'Ciclo ticket (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre'} */
    ],
    configuracion_modal: {
      titulo: "",
      ancho: "xl",
      ruta: "/guias",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "MATERIA PRIMA A PROCESO",
      titulo_boton: "",
      clase_boton: "",
      btn_nuevo: false,
    },
    pagina_actual: "",
    pozos: [],
    alert: false,
    alert_mensaje: "",
    alert_clase: "",
    alert_icono: "",
    alert_errores: [],
    ticket_actual: {},
    distribuciones: [],
    distribuciones_pozo: [],
    alert_distribucion: false,
    alert_distribucion_mensaje: "",
    alert_distribucion_clase: "",
    alert_distribucion_icono: "",
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    console.log("storage", storage);
    this.cargar_pozos();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_pozos() {
      await this.axios
        .get(`${this.api}/pozos?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.pozos = res.data.data.data;
          //this.$set(this.columnas[7],'opciones',this.pozos);
          //this.$set(this.inputs[2],'opciones',this.ciclos_ticket);
          ////console.log('tickets',res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.$emit("cargar");
      //this.cargar('?');
    },

    retornar_pozos(guia_distribuciones_id){
      if(guia_distribuciones_id){
        return this.pozos
        let tiene_restriccion = this.distribuciones.find(d => d.guia_distribuciones_id == guia_distribuciones_id).tiene_restriccion
        if(tiene_restriccion == 0){
          return this.pozos
        }
        return this.pozos.filter(p => p.estado_actual == tiene_restriccion)
      }
      return []
    },

    async cargar($event) {
      //console.log('cargando',$event);
      /* if(!$event.includes('&destino=1&mp_tipos_id=1')){
            $event+='&destino=1&mp_tipos_id=1'; // 1 corresponde a Destinos de Proceso Harina y Aceite
          } */
      //$event = $event.replace('?','?destino=5');
      this.pagina_actual = `${this.api}/guia_distribucion_proceso${$event}`;
      this.lista = [];
      await this.axios
        .get(
          `${this.api}/guia_distribucion_proceso${$event}`,
          this.cabeceras_json
        )
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //console.log(e);
          });
      }
    },

    async distribuir($event) {
      this.distribuciones = [];
      this.distribuciones_pozo = [];
      this.ticket_actual = $event.item;
      let id = $event.item.tickets_id;
      //console.log('event',$event);

      await this.axios
        .get(
          `${this.api}/tickets/${id}/distribuciones_pozo`,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log('distribuciones',res.data.data);
          this.distribuciones = res.data.data.guia_distribuciones;
          this.distribuciones_pozo = res.data.data.distribuciones_pozo;
          /* if(res.data.success){
              this.alert_clase = 'alert-success';
              this.alert_icono = 'fas fa-check-circle'
            }else{
              this.alert_clase = 'alert-danger';
              this.alert_errores = res.data.errores;
              this.alert_icono = 'fas fa-exclamation-circle';
            }
            this.alert_mensaje = res.data.mensaje;
            this.alert = true; */
        })
        .catch((e) => {
          //console.log(e);
        });
      $("#distribucion_pozo").modal({ show: true });
    },

    async guardar_distribuciones_pozo() {
      this.alert = false;
      this.alert_mensaje = "";
      this.alert_clase = "";
      this.alert_icono = "";
      this.alert_errores = [];
      let body = {
        distribuciones_pozo: this.distribuciones_pozo,
        distribuciones: this.distribuciones,
        ticket: this.ticket_actual,
      };
      await this.axios
        .post(
          `${this.api}/guardar_distribuciones_pozo`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          if (res.data.success) {
            this.alert_clase = "alert-success";
            this.alert_icono = "fas fa-check-circle";
            this.distribuciones_pozo = res.data.distribuciones;
          } else {
            this.alert_clase = "alert-danger";
            this.alert_errores = res.data.errores;
            this.alert_icono = "fas fa-exclamation-circle";
          }
          this.alert_mensaje = res.data.mensaje;
          this.alert = true;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_url(this.pagina_actual);
    },

    actualizar_cantidad_kilos(distribucion_pozo, idx) {
      let distri = this.distribuciones.find(
        (d) =>
          d.guia_distribuciones_id == distribucion_pozo.guia_distribuciones_id
      );
      //console.log('distri',distri);
      let index = this.distribuciones.findIndex(
        (d) =>
          d.guia_distribuciones_id == distribucion_pozo.guia_distribuciones_id
      );

      if (distri) {
        let peso_x_bins = distri.peso_real / distri.cantidad_bins;
        this.distribuciones_pozo[idx].cantidad_kilos = Math.round(
          peso_x_bins * distribucion_pozo.cantidad_bins
        );
        let bins_distribuidos = this.distribuciones_pozo
          .filter(
            (dp) => dp.guia_distribuciones_id == distri.guia_distribuciones_id
          )
          .reduce(function (acc, obj) {
            return acc + parseInt(obj.cantidad_bins);
          }, 0);
        //console.log('distribuidos',bins_distribuidos);
        this.distribuciones[index].bins_restantes =
          parseInt(distri.cantidad_bins) - bins_distribuidos;
      }
    },

    async eliminar_distribucion_pozo(distribucion_pozo, idx) {
      let distri = this.distribuciones.find(
        (d) =>
          d.guia_distribuciones_id == distribucion_pozo.guia_distribuciones_id
      );
      let index = this.distribuciones.findIndex(
        (d) =>
          d.guia_distribuciones_id == distribucion_pozo.guia_distribuciones_id
      );
      if (distribucion_pozo.id != null) {
        await this.axios
          .delete(
            `${this.api}/distribucion_pozo/${distribucion_pozo.id}`,
            this.cabeceras_json
          )
          .then((res) => {})
          .catch((e) => {
            //console.log(e);
          });
      }
      this.distribuciones_pozo.splice(idx, 1);
      let bins_distribuidos = this.distribuciones_pozo.reduce(function (
        acc,
        obj
      ) {
        return acc + parseInt(obj.cantidad_bins);
      },
      0);
      this.distribuciones[index].bins_restantes =
        parseInt(distri.cantidad_bins) - bins_distribuidos;
    },

    distribucion_pozo_estanque(distribucion_pozo, idx) {
      //console.log(distribucion_pozo);
      let distri = this.distribuciones.find(
        (d) =>
          d.guia_distribuciones_id == distribucion_pozo.guia_distribuciones_id
      );
      let index = this.distribuciones.findIndex(
        (d) =>
          d.guia_distribuciones_id == distribucion_pozo.guia_distribuciones_id
      );
      let kilos =
        distri.peso_real / parseInt(distribucion_pozo.division_estanque);
      this.distribuciones_pozo[idx].cantidad_kilos = kilos;
    },

    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    agregar_distribucion_pozo() {
      this.distribuciones_pozo.push({
        id: null,
        pozos_id: null,
        cantidad_bins: null,
        cantidad_kilos: null,
        division_estanque: null,
        guia_distribuciones_id: null,
      });
    },

    async guardar_distribucion(d, idx) {
      this.alert_distribucion_clase = "";
      this.alert_distribucion_mensaje = "";
      this.alert_distribucion_icono = "";
      this.alert_distribucion = false;
      let total = 0;
      this.distribuciones.forEach((i) => {
        if (i.cantidad) {
          total += Number(i.cantidad);
        }
      });
      let restante = this.distribucion_actual.peso_real - total;
      if (restante >= 0) {
        await this.axios
          .post(`${this.api}/distribucion_pozo`, d, this.cabeceras_json)
          .then((res) => {
            this.alert_distribucion_clase = "alert-success";
            this.alert_distribucion_mensaje = `Materia prima ingresada a Pozo`;
            this.alert_distribucion_icono = "fas fa-check-circle";
            this.alert_distribucion = true;
            this.distribuciones[idx].id = res.data.data.id;
            this.cargar_url(this.pagina_actual);
          })
          .catch((e) => {
            //console.log(e);
          });
      } else {
        this.alert_distribucion_clase = "alert-danger";
        this.alert_distribucion_mensaje = `No Puede Distribuir mas Materia Prima que el Total ${this.distribucion_actual.peso_real}`;
        this.alert_distribucion_icono = "fas fa-exclamation-circle";
        this.alert_distribucion = true;
      }
    },

    abrirPdf(link) {
      window.open(link, "_blank");
    },

    /* ver_documento(event){
          window.open(`${event.item.url}`, '_blank');
        }, */
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },

    kilos_restantes() {
      if (this.ticket_actual) {
        let total = 0;
        this.distribuciones_pozo.forEach((i) => {
          if (i.cantidad_kilos) {
            total += Number(i.cantidad_kilos);
          }
        });
        return this.ticket_actual.peso_real - total;
      }
      return 0;
    },

    bins_restantes() {
      if (this.ticket_actual) {
        let total = 0;
        this.distribuciones_pozo.forEach((i) => {
          if (i.cantidad_bins) {
            total += Number(i.cantidad_bins);
          }
        });
        return this.ticket_actual.cantidad_bins_proceso - total;
      }
      return 0;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>